module.exports = __webpack_public_path__ + "bcc607b1624cd735c96bcf45972fc272.svg";